import { makeStyles, Snackbar, SnackbarProps, Theme } from "@material-ui/core";
import { Alert, AlertProps } from "@material-ui/lab";
import { useState } from "react";

function MuiAlert(props: AlertProps) {
	return <Alert elevation={6} variant="filled" {...props} />;
}

export default function SnackBar(props: { message: string; snackProps?: SnackbarProps; alertProps: AlertProps }) {
	const classes = useStyles();
	const [open, setOpen] = useState(true);

	const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
		if (event && reason === "clickaway") {
			return;
		}
		setOpen(false);
	};

	function getClass(severity: AlertProps["severity"]) {
		switch (severity) {
			case "error":
				return classes.error;
			case "warning":
				return classes.warning;
			default:
				return classes.success;
		}
	}

	return (
		<div className={classes.root}>
			<Snackbar open={open} autoHideDuration={props.snackProps?.autoHideDuration || 6000} onClose={handleClose} {...props.snackProps}>
				<MuiAlert
					onClose={handleClose}
					severity={props.alertProps.severity}
					{...props.alertProps}
					className={getClass(props.alertProps.severity)}
				>
					{props.message}
				</MuiAlert>
			</Snackbar>
		</div>
	);
}

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		width: "100%",
		"& > * + *": {
			marginTop: theme.spacing(2),
		},
	},
	success: {
		backgroundColor: theme.palette.success.light,
	},
	error: {
		backgroundColor: theme.palette.error.light,
	},
	warning: {
		backgroundColor: theme.palette.warning.light,
	},
}));
